<template>
  <div>
    <v-row v-show="showList">
      <v-col cols="12">
        <RecursosFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :responsaveis="listResponsavel"
          :statusList="statusList"
          :filterList="(formData) => getList(formData, 1)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :carteiras="carteiras"
          :temPermissaoCarteira="temPermissaoCarteira"
        />
      </v-col>
    </v-row>
    <!-- <v-row wrap class="px-4">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        depressed
        outlined
        height="30px"
        small
        class="px-2 ml-2"
        to="/recebiveis/recursosdeglosa/historicodeuploads"
        >Gestão de upload</v-btn>
     <v-btn
        color="primary"
        depressed
        height="30px"
        small
        class="px-2 ml-2"
        @click="showUploadDlg=true"
        >Upload planilha de recurso</v-btn>
    </v-row> -->
    <v-row wrap>
      <v-col class="col-xs-12 col-sm-12 col-md-12 py-0 px-4">
        <List
          v-show="showList"
          tipoFiltro="PAGAMENTO"
          :list="filteredList"
          :filterData="filterList"
          :getList="(filterData, page) => getList(filterData, page)"
          :getPagamentos="(id) => getPagamentos(id)"
          :headers="headers"
          :pagination="pagination"
          :pagtoList="pagtoList"
          :selectItem="(id) => goTodetails(id)"
          :statusList="statusList"
          :uploadRecurso="(pagamento) => openUploadRecurso(pagamento)"
          :totais="totaisGlosa"
        />
      </v-col>
    </v-row>
    <UploadRecursoDlg
      :close="
        () => {
          getList(filterList, pagination.offset);
          showUploadDlg = false;
        }
      "
      :dialog="showUploadDlg"
      :grupoEconomico="grupoEconomico"
      :dadosPagamento="selectedItem"
    />
    <!-- :operadoras="listOperadora"
      :prestadores="prestadores" -->
    <!-- <PagamentoDetalheDlg
      :dialog="showPgto"
      :close="() => showPgto = false"
      :historico="historicoEdicoes"
      /> -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import List from "@/components/recebiveis/recursos_de_glosa/List";
import RecursosFilter from "@/components/recebiveis/recursos_de_glosa/RecursosFilter";
import UploadRecursoDlg from "@/components/recebiveis/recursos_de_glosa/UploadRecursoDlg";

export default {
  components: {
    List,
    RecursosFilter,
    UploadRecursoDlg,
  },
  data() {
    return {
      editItem: {},
      filteredList: [],
      statusList: [],
      pagtoList: [],
      carteiras: [],
      filterList: {},
      controlResponsavel: true,
      showDados: false,
      headers: [
        {
          text: "Data do Pgto",
          value: "date_pag",
          align: "center",
          sortable: false,
        },
        {
          text: "Prazo do Recurso",
          value: "date_prazo",
          align: "center",
          sortable: false,
        },
        {
          text: "Operadora",
          value: "oper_nome",
          align: "left",
          sortable: false,
        },
        {
          text: "Prestador",
          value: "prest_nome",
          align: "left",
          sortable: false,
        },
        {
          text: "Vl.informado",
          value: "pagto_estimado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.liberado",
          value: "val_liberado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.glosado",
          value: "pagto_glossado",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.recursado",
          value: "val_glos_rec",
          align: "right",
          sortable: false,
        },
        {
          text: "Vl.acatado",
          value: "val_glos_acat",
          align: "right",
          sortable: false,
        },
        { text: "Estado", value: "status", align: "center", sortable: false },
      ],
      pagination: {
        limit: 20,
        offset: 1,
        current_page: 1,
        total_pages: 1,
      },
      paginationPagto: {
        limit: 10,
        offset: 1,
        current_page: 1,
        total_pages: 1,
      },
      prestadores: [],
      showList: true,
      showPgto: false,
      showUploadDlg: false,
      selectedItem: {},
      totaisGlosa: {
        valor_informado: 0,
        valor_liberado: 0,
        valor_liberado_producao: 0,
        valor_glosado: 0,
        valor_recursado: 0,
        perc_conciliado: 0,
        valor_glosa_mantida: 0,
        valor_liberado_recurso: 0,
        valor_acatado: 0,

      },
      temPermissaoCarteira: false,
    };
  },
  watch: {
    grupoEconomicoList: {
      deep: true,
      handler() {
        this.prestadores =
          this.$store.getters["permissions/getPrestadoresByGeco"]();
        this.verificaPermissaoCarteiras();
      },
    },
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: (state) => state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      listResponsavel: (state) => state.recebiveis.listResponsavel,
      permissao: (state) => state.permissions.permissaoBase,
      permissaoUsuario: (state) => state.userData.userData.PermissaoAcoes,
      userData: (state) => state.userData.userData,
    }),
  },
  beforeMount() {
    let opts = {
      grupoEconomico: this.grupoEconomico,
      grupo_economico: this.grupoEconomico,
      limitar: false,
      modulo_operadora: "faturamento",
      origem: "recurso",
    };
    this.getOperadoras({
      grupoEconomico: this.grupoEconomico,
      prestador_ids: [],
      modulo_operadora: "recebiveis",
    });
    this.getResponsaveis(opts);
    this.getEtapasPagamento(opts);
    this.prestadores =
      this.$store.getters["permissions/getPrestadoresByGeco"]();
    this.verificaPermissaoCarteiras();
  },
  // mounted(){
  // },
  methods: {
    ...mapActions("permissions", ["getOperadoras"]),
    ...mapActions("recebiveis", ["getResponsaveis"]),
    openUploadRecurso(pagamento) {
      if (pagamento.erro_validacao) {
        let paramModal = {
          type: "warning",
          title: "Atenção!",
          message:
            "Existem arquivos com erro! <br>Exclua os arquivos com erro antes de enviar novos arquivos.",
          callback: null,
          btConfirm: { name: "Ok", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        return;
      }
      this.selectedItem = pagamento;
      this.showUploadDlg = true;
    },
    getEtapasPagamento(payload) {
      let obj = {
        query: [{ modulo: "Recebiveis", acao: "getetapaspagamento", payload }],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.statusList = response.dados;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      let [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    saveFilter(filter) {
      this.filterList = filter;
      this.filterList.grupo_economico = this.grupoEconomico;

      let opts = {
        filterData: {
          grupo_economico: this.grupoEconomico,
          ...filter,
        },
        filterName: "recursosGlosaFilter",
        redirect: false,
      };
      this.$store.commit("recebiveis/setFilter", opts, { root: true });
    },
    async getList(filter, page) {
      this.filteredList = [];
      filter = filter ? filter : this.filterList;
      this.pagination.offset = page ? page : 1;
      let payload = Object.assign(
        this.pagination,
        { grupo_economico: this.grupoEconomico },
        filter
      );
      let obj = {
        query: [
          { modulo: "Recebiveis", acao: "getrecursosglosa", payload: payload },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          let {
            total_pages,
            current_page,
            dados,
            perc_conciliado,
            valor_informado,
            valor_liberado,
            valor_recursado,
            valor_acatado,
            valor_liberado_producao,
            valor_glosado,
            valor_liberado_recurso,
            valor_glosa_mantida,
          } = response;

          this.filteredList = dados;
          this.pagination.total_pages = total_pages;
          this.pagination.offset = current_page;
          this.pagination.current_page = current_page;
          this.totaisGlosa.valor_informado = valor_informado;
          this.totaisGlosa.valor_liberado = valor_liberado;
          this.totaisGlosa.valor_glosado = valor_glosado;
          this.totaisGlosa.valor_glosa_mantida = valor_glosa_mantida;
          this.totaisGlosa.valor_recursado = valor_recursado;
          this.totaisGlosa.valor_acatado = valor_acatado;
          this.totaisGlosa.valor_liberado_recurso = valor_liberado_recurso;
          this.totaisGlosa.valor_liberado_producao = valor_liberado_producao;
          this.totaisGlosa.perc_conciliado = perc_conciliado;

          this.saveFilter(filter);
        });
    },
    getPagamentos(id, page) {
      this.pagtoList = [];
      this.paginationPagto.offset = page ? page : 1;
      let payload = Object.assign(this.paginationPagto, {
        grupo_economico: this.grupoEconomico,
        id: id,
      });
      let obj = {
        query: [
          {
            modulo: "Recebiveis",
            acao: "getrecursosglosapagamentos",
            payload: payload,
          },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          let { total_pages, current_page, dados } = response;
          this.pagtoList = dados;
          this.paginationPagto.total_pages = total_pages;
          this.paginationPagto.offset = current_page;
          this.paginationPagto.current_page = current_page;
        });
    },
    saveItem(formData) {
      let opts = {};
      if (formData == null) {
        opts = Object.assign(
          this.pagination,
          { grupo_economico: this.grupoEconomico, limitar: false },
          this.filter
        );
        this.getCronogramas(opts).then(() => (this.showList = true));
        return;
      }
      formData.grupo_economico = this.grupoEconomico;

      let acao = formData.id ? "updatecronograma" : "addcronograma";
      let payload = formData;

      var data = {
        query: [
          {
            Modulo: "faturamento",
            Acao: acao,
            Payload: payload,
          },
        ],
      };

      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getCronogramas(opts).then(() => (this.showList = true));
          },
          btConfirm: { name: "Ok", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    deleteCronograma(id) {
      let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "deletecronograma",
            Payload: {
              Id: id,
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj);
    },
    getCarteiras() {
      let obj = {
        query: [
          {
            modulo: "Carteira",
            acao: "getcarteiras",
            payload: { grupo_economico: this.grupoEconomico, user: true },
          },
        ],
      };
      this.$store
        .dispatch("request/doRequest", obj, { root: true })
        .then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader");
            return;
          }
          this.carteiras = response.dados;
        });
    },
    verificaPermissaoCarteiras() {
      if (
        Object.keys(this.permissao).includes("carteira") &&
        Object.keys(this.permissaoUsuario).includes("carteira") &&
        this.permissaoUsuario.carteira.includes("getcarteiras")
      ) {
        this.getCarteiras();
        this.temPermissaoCarteira = true;
      } else {
        this.temPermissaoCarteira = false;
      }
    },
  },
};
</script>
<style>
</style>
